// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1zCsr","large":"styles_large__1q0B9"};